import { initAxiosRH, loadAbort } from "#api/axios.service"
const axios=initAxiosRH()
const VACANTES="vacantes"
const VACANCY="vacancy"
const CANDIDATO="candidatos"
const INGRESO=(id)=> `${CANDIDATO}/${id}/ingreso`

export const vacantesGet = (params) => {
    const controller= loadAbort()
    const call= axios.get(VACANCY,{params,signal:controller.signal})
    return {call,controller}
}

export const vacanteGet = (vacanteId) => {
    const controller= loadAbort()
    const call= axios.get(`${VACANCY}/${vacanteId}`,{signal:controller.signal})
    return {call,controller}
}

export const vacantesIngresoGet = ({id,params}) => {
    const controller= loadAbort()
    const call= axios.get(INGRESO(id),{params,signal:controller.signal})
    return {call,controller}
}
export const vacantesIngresoPut = (id,data,params) => {
    const controller= loadAbort()
    const call= axios.put(INGRESO(id),data,{params,signal:controller.signal})
    return {call,controller}
}